
export const backend_server = "https://morning-ridge-83239.herokuapp.com/api/"